var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { HearingInNoisyPlacesContent } from './hearing-in-noisy-places-content.component';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
import { Typography } from '@mui/material';
export function HearingInNoisyPlacesSelect() {
    return (_jsx(StepLayout, { image: pageImages.elderlyManWithHeadphones, progress: {
            phase: 0,
            step: 1,
        }, heading: _jsx(Typography, __assign({ variant: "h3", className: "md:pt-6 lg:pt-12 xl:pt-[72px] font-extrabold text-charcoal text-2xl lg:text-4xl" }, { children: "Do you ever struggle to hear in noisy places?" })), content: _jsx(HearingInNoisyPlacesContent, {}), nav: _jsx(NavigationButtonsContainer, __assign({ className: 'mb-6' }, { children: _jsx(NavigationButton, { type: "submit", variant: "contained", label: "Next", className: 'sm:max-w-60' }) })) }));
}
